<div class="main-content">
  <app-header
    [title]="'MACHINE_MODULES.FORM_TITLE' | translate"
    [subtitle]="serialNumber || ''"
  />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      <app-icam-container [centralIcon]="true" [iconName]="'key'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
        @if (!isLoading) {
          <div class="form-container d-flex flex-column">
            <div class="form-section modules-section w-100">
              <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
                <div class="d-flex align-items-center p-1">
                  <img
                    class="section-image"
                    src="../../assets/icon/add-section-white.svg"
                    alt="moduli"
                    style="width: 24px; height: 24px"
                  />
                </div>
                <div class="form-title-text-container">
                  <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                    {{ 'MACHINE_MODULES.SECTION_TITLE' | translate }}
                  </p>
                </div>
              </div>
              <p class="modules-description" [ngClass]="isLight ? 'light' : 'dark'">
                {{ 'MACHINE_MODULES.SECTION_DESCRIPTION' | translate }}
              </p>
              <div class="modules-grid">
                @for (module of moduleRegistry; track module.code) {
                  <div class="module-item">
                    <button
                      type="button"
                      class="btn rounded d-flex align-items-center justify-content-center mb-1 w-100 module-button"
                      [ngStyle]="
                        isEnabled(module.code)
                          ? { background: '#E30613', borderColor: '#E30613', color: '#fff' }
                          : { background: '#fff', borderColor: '#6c757d', color: '#6c757d' }
                      "
                      [disabled]="isSaving"
                      (click)="onToggle(module.code, !isEnabled(module.code))"
                    >
                      <img
                        [src]="'../../assets/icon/' + module.icon + (isEnabled(module.code) ? '-white.svg' : '-light.svg')"
                        alt="module-icon"
                        class="img-fluid"
                        style="width: 32px; height: 32px; object-fit: contain"
                      />
                    </button>
                    <div
                      class="small fw-semibold text-center w-100"
                      [ngStyle]="{ color: isLight ? (isEnabled(module.code) ? '#111' : '#6c757d') : '#ffffff' }"
                    >
                      {{ module.labelKey | translate }}
                    </div>
                  </div>
                }
              </div>
              <ul class="modules-legend" [ngClass]="isLight ? 'light' : 'dark'">
                @for (module of moduleRegistry; track module.code) {
                  <li>
                    <strong>{{ module.labelKey | translate }}</strong> —
                    {{ module.descriptionKey | translate }}
                  </li>
                }
              </ul>

              <button type="button" class="button-form-submit" [class.disabled]="!hasChanges() || isSaving" [disabled]="!hasChanges() || isSaving" (click)="onSubmit()">
                @if (isSaving) {
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                  </div>
                } @else {
                  {{ 'MACHINE_MODULES.SAVE' | translate }}
                }
              </button>

              @if (saveStatusMessage) {
                <p
                  class="mt-3 mb-0 text-center"
                  [class.text-success]="saveStatusType === 'success'"
                  [class.text-danger]="saveStatusType === 'error'"
                >
                  {{ saveStatusMessage | translate }}
                </p>
              }
            </div>
          </div>
        }

        @if (isLoading) {
          <div class="loading-container text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
            </div>
            <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
          </div>
        }
      </app-icam-container>
    </div>
  </div>

  <div class="form-footer d-flex justify-content-between mt-4">
    <app-back-button
      class="app-back-button"
      [linkText]="'ODV_DOCUMENTS_FORM.BACK_TO_LIST' | translate"
      (click)="goBack()"
    ></app-back-button>
  </div>
</div>
<app-footer-copyright />
